import { dispatch } from "hf-rt";
import { HOST_URL, ROOT } from "../constants";
import { stringify } from "qs";
import { searchKeywords, loading } from "../models";
import getCookie from "../function/getCookie";
import deleteCookie from "../function/deleteCookie";

const initialState = {
  chosenFilterList: [],
  urlWithFilter: ""
};

// 發送搜尋API時使用的陣列
let criteriaCodeList = [];
// 商品標記位置
let scrollToMarker;
let clearMarker;

export default {
  name: "chosenFilter",
  actions: {
    addFilter: async function(
      data,
      keywords,
      activeSortBy,
      changeUrl = false,
      mySwiper = false
    ) {
      dispatch({ type: "ADD_FILTER", data });
      criteriaCodeList.push(data.code);
      const criteriaCode = criteriaCodeList.map(data => data).join(",");
      const { sortBy, sortDirection } = activeSortBy;
      const params = {
        searchText: keywords,
        page: 1,
        criteriaCode: criteriaCode,
        sortBy: sortBy,
        sortDirection: sortDirection
      };
      const textParams = stringify(params);
      const url = `${HOST_URL}/shopping/v1/catalogItemSearches/search?${textParams}`;
      this.updateFilter(url, mySwiper);
      if (changeUrl) {
        this.updateUrlWithFilter(textParams);
      }
    },
    removeFilter: async function(
      data,
      keywords,
      activeSortBy,
      changeUrl = false,
      mySwiper = false
    ) {
      dispatch({ type: "REMOVE_FILTER", data });
      const index = criteriaCodeList.findIndex(item => item === data.code);
      criteriaCodeList.splice(index, 1);
      const criteriaCode = criteriaCodeList.map(data => data).join(",");
      const { sortBy, sortDirection } = activeSortBy;
      const params =
        criteriaCode !== ""
          ? {
              searchText: keywords,
              page: 1,
              criteriaCode: criteriaCode,
              sortBy: sortBy,
              sortDirection: sortDirection
            }
          : {
              searchText: keywords,
              page: 1,
              sortBy: sortBy,
              sortDirection: sortDirection
            };
      const textParams = stringify(params);
      const url = `${HOST_URL}/shopping/v1/catalogItemSearches/search?${textParams}`;
      this.updateFilter(url, mySwiper);
      if (changeUrl) {
        this.updateUrlWithFilter(textParams);
      }
    },
    clearAllFilter: async function(keywords, activeSortBy, changeUrl = false) {
      dispatch({ type: "CLEAR_ALL_FILTER" });
      criteriaCodeList.length = 0;
      const { sortBy, sortDirection } = activeSortBy;
      const params = {
        searchText: keywords,
        page: 1,
        sortBy: sortBy,
        sortDirection: sortDirection
      };
      const textParams = stringify(params);
      const url = `${HOST_URL}/shopping/v1/catalogItemSearches/search?${textParams}`;
      this.updateFilter(url);
      if (changeUrl) {
        this.updateUrlWithFilter(textParams);
      }
    },
    loadMoreProducts: async function(
      keywords,
      activePage,
      activeSortBy,
      oldSearchProductList,
      mySwiper = null
    ) {
      dispatch({ type: "LOAD_MORE_PRODUCTS" });
      // 更新頁面為下一頁
      searchKeywords.actions.updatePage(activePage + 1);
      // 顯示載入畫面
      loading.actions.startLoading(true);
      // 固定背景
      document.body.style.overflow = "hidden";
      const criteriaCode = criteriaCodeList.map(data => data).join(",");
      const { sortBy, sortDirection } = activeSortBy;
      let params;
      if (sortBy === "") {
        if (criteriaCode === "") {
          params = {
            searchText: keywords,
            page: activePage + 1
          };
        } else {
          params = {
            searchText: keywords,
            page: activePage + 1,
            criteriaCode: criteriaCode
          };
        }
      } else {
        if (criteriaCode === "") {
          params = {
            searchText: keywords,
            page: activePage + 1,
            sortBy: sortBy,
            sortDirection: sortDirection
          };
        } else {
          params = {
            searchText: keywords,
            page: activePage + 1,
            criteriaCode: criteriaCode,
            sortBy: sortBy,
            sortDirection: sortDirection
          };
        }
      }
      const textParams = stringify(params);
      const url = `${HOST_URL}/shopping/v1/catalogItemSearches/search?${textParams}`;
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          },
          credentials: "include"
        });
        if (response.status === 200) {
          const data = await response.json();
          const searchProductList = data.productRefinements[0].productList;
          // 將下一個page抓取到的新商品填入原先的陣列中
          for (var i = 0; i < searchProductList.length; i++) {
            oldSearchProductList.push(searchProductList[i]);
          }
          searchKeywords.actions.updateSearchResult(
            data.productRefinements[0],
            oldSearchProductList
          );
          // 更新網址
          this.updateUrlWithFilter(textParams);
          // 滾動至商品標記位置事件
          const marker = getCookie("product-marker");
          clearTimeout(scrollToMarker);
          clearTimeout(clearMarker);
          if (marker) {
            // 2秒後移動至上次停留的商品位置
            scrollToMarker = setTimeout(() => {
              window.scrollTo({
                top: parseInt(marker)
              });
            }, 2000);
            // 3秒後消除商品停留位置的cookie
            clearMarker = setTimeout(() => {
              deleteCookie("product-marker");
            }, 3000);
          }
        } else {
          window.logApiErrors(
            "r",
            "loadMoreProducts",
            response.status,
            response.statusText
          );
        }
      } catch {
      } finally {
        // 停止載入畫面
        loading.actions.startLoading(false);
        // 解除固定背景
        document.body.style.overflow = "";
        if (mySwiper) {
          // 有傳mySwiper的值，就更新mySwiper樣式
          mySwiper.update();
        }
      }
    },
    updateFilter: async function(url, mySwiper = false) {
      // 顯示載入畫面
      loading.actions.startLoading(true);
      // 資料清空
      // searchKeywords.actions.updateSearchResult(null, []);
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          },
          credentials: "include"
        });
        if (response.status === 200) {
          const data = await response.json();
          const searchProductList = data.productRefinements[0].productList;
          // 載入新的資訊、商品
          searchKeywords.actions.updateSearchResult(
            data.productRefinements[0],
            searchProductList
          );
          // 更新頁面回第一頁
          searchKeywords.actions.updatePage(1);
          if (mySwiper) {
            // 更新Swiper樣式
            mySwiper.update();
          }
        } else {
          searchKeywords.actions.updateSearchResult(null, []);
          window.logApiErrors(
            "r",
            "updateFilter",
            response.status,
            response.statusText
          );
          throw new Error("search error");
        }
      } catch (error) {
        console.log(error);
      } finally {
        loading.actions.startLoading(false);
      }
    },
    updateUrlWithFilter: function(url) {
      // 紀錄目前的網址
      dispatch({ type: "UPDATE_URL_WITH_FILTER", url });
      window.history.pushState(null, null, `${ROOT}/search?${url}`);
    },
    addFilterWithUrl: async function (data) {
      criteriaCodeList.push(data.code);
      dispatch({ type: "ADD_FILTER", data });
    }
  },
  reducers: function(state = initialState, action) {
    switch (action.type) {
      case "ADD_FILTER":
        return {
          ...state,
          chosenFilterList: [...state.chosenFilterList, action.data]
        };
      case "REMOVE_FILTER":
        let newArray = [...state.chosenFilterList];
        const index = newArray.findIndex(
          item => item.code === action.data.code
        );
        newArray.splice(index, 1);

        return {
          ...state,
          chosenFilterList: newArray
        };
      case "CLEAR_ALL_FILTER":
        let emptyArray = [...state.chosenFilterList];
        emptyArray.length = 0;
        return {
          ...state,
          chosenFilterList: emptyArray
        };
      case "UPDATE_URL_WITH_FILTER":
        return {
          ...state,
          urlWithFilter: action.url
        };
      default:
        return state;
    }
  }
};
